import { useEffect } from "react";
import axiosInstance from "../../../../axiosInstance";
import { format } from "date-fns";
import { useState } from "react";

function usePhysicalInventorySubmissions(storeId, fromDate, toDate) {
  const [submissions, setSubmissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getSubmissions() {
      if (!storeId || !fromDate || !toDate) return;
      try {
        setIsLoading(true);
        const result = await axiosInstance.post(
          "/physicalInventory/getSubmissions",
          {
            storeId,
            fromDate: format(fromDate, "MM-dd-yyyy"),
            toDate: format(toDate, "MM-dd-yyyy"),
          }
        );
        setSubmissions(result.data.data);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }

    getSubmissions();
  }, [storeId, fromDate, toDate]);
  return { submissions, isLoading };
}

export default usePhysicalInventorySubmissions;
